import * as yup from 'yup'

export const parsePaymentAmount = (value: string | null): bigint | null => {
  if (value === null) return null

  const normalized = value.replace(/\s/g, '').replace(',', '.')
  if (!/^\d+(?:\.\d{1,2})?$/.test(normalized)) return null

  const [whole, fraction = ''] = normalized.split('.')
  const integer = whole.replace(/^0+(?=\d)/, '')
  if (integer.length > 30) return null

  return BigInt(integer) * 100n + BigInt(fraction.padEnd(2, '0'))
}

export const serializePaymentAmount = (amount: bigint): string =>
  `${amount / 100n}.${(amount % 100n).toString().padStart(2, '0')}`

export const formatPaymentAmount = (value: string | null): string => {
  const amount = parsePaymentAmount(value)
  if (amount === null) return '—'

  const fraction = amount % 100n
  return `${(amount / 100n).toLocaleString('ru-RU')}${
    fraction ? `,${fraction.toString().padStart(2, '0')}` : ''
  }`
}

export const paymentAmountSchema = (
  remainingAmount: string | null,
  messages: { invalid: string; minimum: string; maximum: string },
) =>
  yup
    .string()
    .required(messages.invalid)
    .test('amount', messages.invalid, (value, context) => {
      const amount = parsePaymentAmount(value)
      const remaining = parsePaymentAmount(remainingAmount)
      if (amount === null || remaining === null)
        return context.createError({ message: messages.invalid })
      if (amount < 1n) return context.createError({ message: messages.minimum })
      if (amount > remaining) {
        return context.createError({ message: messages.maximum })
      }
      return true
    })
